import type { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import type { ProductDetail } from '@lead-forms/Entities/Product.entity';

const doesDriftRockModelMatchVehicle = (vehicle: Vehicle, driftRockProduct: ProductDetail) => {
  return (
    vehicle.make.id === driftRockProduct.productTarget.make &&
    vehicle.model.id === driftRockProduct.productTarget.model
  );
};

export { doesDriftRockModelMatchVehicle };
